import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { FileCheck, AlertCircle, CheckCircle, ArrowLeft } from 'lucide-react';

import { API_URL } from '../config';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore nell\'invio dell\'email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-10">
          <div className="w-10 h-10 bg-forest rounded-sm flex items-center justify-center">
            <FileCheck className="w-5 h-5 text-white" strokeWidth={1.5} />
          </div>
          <span className="text-xl font-bold tracking-tight text-forest">BustaControllo</span>
        </div>

        <div className="bg-white p-8 rounded-lg shadow-sm border border-slate-200">
          {success ? (
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-emerald-600" />
              </div>
              <h1 className="text-2xl font-bold mb-2">Email Inviata!</h1>
              <p className="text-muted-foreground mb-6">
                Se esiste un account con questa email, riceverai le istruzioni per reimpostare la password.
              </p>
              <Link to="/login">
                <Button className="swiss-btn-primary w-full">
                  Torna al Login
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold mb-2">Password Dimenticata?</h1>
              <p className="text-muted-foreground mb-6">
                Inserisci la tua email e ti invieremo le istruzioni per reimpostare la password.
              </p>

              {error && (
                <div className="flex items-center gap-2 p-4 mb-6 bg-red-50 border border-red-200 text-red-700 text-sm rounded-sm">
                  <AlertCircle className="w-4 h-4 flex-shrink-0" />
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="space-y-2">
                  <Label htmlFor="email" className="label-uppercase">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="nome@esempio.com"
                    className="swiss-input h-12"
                    data-testid="forgot-email"
                    required
                  />
                </div>

                <Button
                  type="submit"
                  className="swiss-btn-primary w-full h-12"
                  disabled={loading}
                  data-testid="forgot-submit"
                >
                  {loading ? (
                    <span className="flex items-center gap-2">
                      <span className="spinner" />
                      Invio in corso...
                    </span>
                  ) : (
                    'Invia Istruzioni'
                  )}
                </Button>
              </form>

              <Link 
                to="/login" 
                className="flex items-center justify-center gap-2 mt-6 text-sm text-muted-foreground hover:text-forest"
              >
                <ArrowLeft className="w-4 h-4" />
                Torna al Login
              </Link>
            </>
          )}
        </div>
        
        {/* Copyright */}
        <p className="mt-6 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} BustaControllo. Tutti i diritti riservati.
        </p>
      </div>
    </div>
  );
}
